<div class="container-fluid">
  <!-- Page Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h1 class="h2 mb-1 fw-bold">Drone Catalog</h1>
      <p class="text-muted mb-0">Manage drone manufacturers and their models</p>
    </div>
    <button type="button" class="btn btn-primary" (click)="createManufacturer()">
      <i class="bi bi-plus-lg me-2"></i>
      Add Manufacturer
    </button>
  </div>

  <!-- Error Alert -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''"></button>
  </div>

  <!-- Search Card -->
  <div class="card mb-4">
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <!-- Search -->
        <div class="col-md-6">
          <label class="form-label">Search Manufacturers</label>
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Search by name..."
              [(ngModel)]="searchQuery"
              (keyup.enter)="onSearch()"
              (input)="onSearch()"
            />
            <button class="btn btn-outline-secondary" type="button" (click)="onSearch()">
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading manufacturers...</p>
  </div>

  <!-- Manufacturers Grid -->
  <div *ngIf="!loading" class="row">
    <!-- Empty State -->
    <div *ngIf="filteredManufacturers.length === 0" class="col-12">
      <div class="card">
        <div class="card-body text-center py-5 text-muted">
          <i class="bi bi-collection fs-1 d-block mb-2"></i>
          <span *ngIf="searchQuery">No manufacturers found matching "{{ searchQuery }}"</span>
          <span *ngIf="!searchQuery">No drone manufacturers yet.</span>
        </div>
      </div>
    </div>

    <!-- Manufacturer Cards -->
    <div
      *ngFor="let manufacturer of filteredManufacturers"
      class="col-md-6 col-lg-4 mb-4"
    >
      <div class="card stat-card cursor-pointer h-100" (click)="viewManufacturer(manufacturer)">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square fs-4 me-3">
              <i class="bi bi-cpu"></i>
            </div>
            <div class="flex-grow-1 overflow-hidden">
              <h5 class="card-title mb-0 text-truncate">{{ manufacturer.name }}</h5>
            </div>
          </div>
          <p class="card-text text-muted small" *ngIf="manufacturer.description">
            {{ manufacturer.description | slice:0:100 }}{{ manufacturer.description.length > 100 ? '...' : '' }}
          </p>
          <p class="card-text text-muted small" *ngIf="!manufacturer.description">
            <em>No description</em>
          </p>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              <i class="bi bi-box me-1"></i>
              <span>{{ manufacturer.modelCount || 0 }} model{{ manufacturer.modelCount === 1 ? '' : 's' }}</span>
            </small>
            <i class="bi bi-chevron-right text-muted"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Summary -->
  <div *ngIf="!loading && manufacturers.length > 0" class="text-muted text-center mt-3">
    Showing {{ filteredManufacturers.length }} of {{ manufacturers.length }} manufacturers
  </div>
</div>
